import { Button, Card, Col } from 'antd'
import React from 'react'
import { useHistory } from 'react-router-dom';
import {useSelector} from 'react-redux';
import { getAttachment } from 'utils/attachment';

const { Meta } = Card;

function SearchedElements({ item, locale }) {
    const {storeData} = useSelector(state => state.fetchedData);
    const history = useHistory();

    

    return (
        <Col lg={12} md={6} sm={8} xs={12}>
            <Card
                style={{ cursor: 'pointer' }}
                bodyStyle={{ paddingInline: "14px" }}
                cover={<img className='item-menu__image' style={{ objectFit: 'fill' }} alt="example" src={item?.images?.length ? getAttachment(item?.images[0].id) : '/img/productsFallback.svg'} />}
                onClick={() => history.push('/app/products/' + item?.id)}
            >
                <Meta
                    // className={`${!item?.stock && 'soldOut'}`}
                    title={<span className='text-black'>{(locale === 'en' ? item?.nameEng : item?.nameAr).toUpperCase()}</span>}
                    description={
                        <Button className='card-button text-black w-100 justify-content-center px-3 d-flex align-items-center'>
                            <span> {storeData?.currency?.name ? storeData?.currency.name : "KWD" } {item?.price}</span>
                        </Button>
                    }
                />
            </Card>
        </Col>
    )
}

export default SearchedElements